import { DEFAULT_SECTION_CONTENT_PROPERTIES, } from '../content/contentBuilder/SectionProperties';
export const convertSectionProperties = (properties) => {
    var _a, _b, _c, _d, _e;
    if (properties === null) {
        return DEFAULT_SECTION_CONTENT_PROPERTIES;
    }
    return {
        backgroundColor: properties.backgroundColor,
        paddingTop: (_a = properties.paddingTop) !== null && _a !== void 0 ? _a : DEFAULT_SECTION_CONTENT_PROPERTIES.paddingTop,
        paddingBottom: (_b = properties.paddingBottom) !== null && _b !== void 0 ? _b : DEFAULT_SECTION_CONTENT_PROPERTIES.paddingBottom,
        displayDelayInSeconds: (_c = properties.displayDelayInSeconds) !== null && _c !== void 0 ? _c : DEFAULT_SECTION_CONTENT_PROPERTIES.displayDelayInSeconds,
        maxWidth: (_d = properties.maxWidth) !== null && _d !== void 0 ? _d : DEFAULT_SECTION_CONTENT_PROPERTIES.maxWidth,
        verticalAlignment: (_e = properties.verticalAlignment) !== null && _e !== void 0 ? _e : DEFAULT_SECTION_CONTENT_PROPERTIES.verticalAlignment,
    };
};
